import React from 'react';
import './Confetti.css';

const Confetti = () => {
    const confetti = Array.from({ length: 30 }).map((_, i) => (
        <div key={i} className="confetti-piece" style={{
            '--x': Math.random(),
            '--y': Math.random(),
            '--angle': Math.random() * 360,
            '--delay': Math.random() * 0.5,
            backgroundColor: `hsl(${Math.random() * 360}, 70%, 60%)`
        }}></div>
    ));

    return <div className="confetti-container">{confetti}</div>;
};

export default Confetti;
